import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'displayTotalFine',
  standalone: true,
  pure: false,
})
export class DisplayTotalFinePipe implements PipeTransform {
  private readonly transloco = inject(TranslocoService);

  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) return this.transloco.translate('common.not-defined');
    if (value === 0) return 'N/A';
    return `$${value}`;
  }
}
